import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./header";
import Footer from "./footer";

export default function MeanStackJobs() {
  // Sample job openings data for MEAN stack roles
  const jobOpenings = [
    {
      title: "MEAN Stack Developer",
      company: "Techlight",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "Techlight is seeking a MEAN Stack Developer to work on cutting-edge web applications using MongoDB, Express.js, React.js, and Node.js. Collaborate with a highly skilled team to build scalable applications and solve complex technical challenges.",
    },
    {
      title: "Senior MEAN Stack Engineer",
      company: "InnoTechies",
      location: "India, Remote",
      salary: "₹15L - ₹30L",
      description:
        "Join InnoTechies as a Senior MEAN Stack Engineer, leading development efforts for high-performance web platforms. You’ll work closely with cross-functional teams to deliver clean, efficient code across the full stack (MongoDB, Express.js, React.js, and Node.js).",
    },
    {
      title: "Node.js Backend Developer",
      company: "BackendMasters",
      location: "India, Remote",
      salary: "₹10L - ₹22L",
      description:
        "BackendMasters is looking for a Node.js Developer to design and maintain the server-side logic for our applications. If you are proficient with Node.js and Express.js, apply to work on backend systems that scale.",
    },
    {
      title: "React.js Frontend Developer",
      company: "ReactPros",
      location: "India, Remote",
      salary: "₹12L - ₹25L",
      description:
        "ReactPros is looking for a Frontend Developer with expertise in React.js. Join our team to build beautiful and responsive user interfaces for various web applications.",
    },
    {
      title: "Full Stack MEAN Developer",
      company: "CodeCrafters",
      location: "India, Remote",
      salary: "₹14L - ₹28L",
      description:
        "CodeCrafters is hiring a Full Stack Developer proficient in the MEAN stack. You will be involved in both frontend and backend development, creating seamless and efficient web applications.",
    },
    {
      title: "MEAN Stack Architect",
      company: "VisionaryCoders",
      location: "India, Remote",
      salary: "₹18L - ₹35L",
      description:
        "VisionaryCoders is seeking a MEAN Stack Architect to design and lead the development of complex web applications. This is a leadership role focused on ensuring scalability, performance, and maintainability.",
    },
    {
      title: "Node.js DevOps Engineer",
      company: "DevOpsMasters",
      location: "India, Remote",
      salary: "₹12L - ₹24L",
      description:
        "DevOpsMasters is looking for a Node.js DevOps Engineer to handle the deployment, scaling, and maintenance of Node.js applications. You will ensure smooth CI/CD processes and infrastructure scalability.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>MEAN Stack Developer Jobs 2025</title>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Find remote MEAN stack developer job opportunities with leading companies in 2025."
        />
        <meta
          name="keywords"
          content="MEAN stack developer, remote jobs, MongoDB, Express.js, React, Node.js"
        />
        <meta name="author" content="Your Name" />
      </Helmet>
      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-12 text-center">
            <h1 className="font-weight-bold">MEAN Stack Developer Jobs 2025</h1>
            <p className="lead">
              Explore exciting remote opportunities in MEAN stack development
              with leading companies.
            </p>
          </div>
          {jobOpenings.map((job, index) => (
            <div key={index} className="col-md-12 mb-12">
              <Card>
                <Card.Body>
                  <Card.Title>{job.title}</Card.Title>
                  <Card.Text>{job.salary}</Card.Text>
                  <Card.Subtitle className="mb-12 text-muted">
                    {job.company} - {job.location}
                  </Card.Subtitle>
                  <Card.Text>{job.description}</Card.Text>
                  <div className="d-flex justify-content-between align-items-center">
                    <Button variant="primary">Apply Now</Button>
                    <span>Today</span>
                  </div>
                </Card.Body>
              </Card>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
